// Module
var code = "<div class=\"schema-icon {{$.getStyle()}}\"></div>";
// Exports
export default code;